import proIcon from 'app/assets/pro-new.svg';
import homeIcon from 'app/assets/icons/sidebar/home.svg';
import attentionIcon from 'app/assets/icons/sidebar/attention.svg';
import insightsIcon from 'app/assets/icons/sidebar/insights.svg';
import whatsNewIcon from 'app/assets/icons/sidebar/whats-new.svg';
import ordersIcon from 'app/assets/icons/sidebar/orders.svg';
import patientHelpIcon from 'app/assets/icons/sidebar/patient-help.svg';
import prescribingIcon from 'app/assets/icons/sidebar/prescribing.svg';
import managedRepeatsIcon from 'app/assets/icons/sidebar/managed-repeats.svg';
import questionnairesIcon from 'app/assets/icons/sidebar/questionnaires.svg';
import servicesDashboardIcon from 'app/assets/icons/sidebar/services-dashboard.svg';
import pgdsIcon from 'app/assets/icons/sidebar/pgds.svg';
import otcUberCatalogueIcon from 'app/assets/icons/sidebar/otc-uber-catalogue.svg';
import branchCatalogueIcon from 'app/assets/icons/sidebar/branch-catalogue.svg';
import productLibraryIcon from 'app/assets/icons/sidebar/product-library.svg';
import marketingMaterialsIcon from 'app/assets/icons/sidebar/marketing-materials.svg';
import inAppBannerIcon from 'app/assets/icons/sidebar/in-app-banner.svg';
import billingAndReportsIcon from 'app/assets/icons/sidebar/billing-and-reports.svg';
import trainingAndGuidesIcon from 'app/assets/icons/sidebar/training-and-guides.svg';
import reviewsIcon from 'app/assets/icons/sidebar/reviews.svg';
import pharmaciesIcon from 'app/assets/icons/sidebar/pharmacies.svg';
import usersIcon from 'app/assets/icons/sidebar/users.svg';
import { authRoles } from 'app/auth';

import {
  broadcastsItem,
  calendarItem,
  lunarReviewsItem,
  masterServicesItem,
  patientsItem,
  servicesItem,
  smsCampaignsItem,
  superLinksItem,
  userManagementItem,
  websiteBuilderItem,
} from './sharedNavigationItems';

import config from '../../../../config.json';

// `plusFeature` names the resolved organisation feature behind a Plus+ page: once the new pricing
// launches, the sidebar tags the item Plus+ for organisations without it (see SidebarItemTag), and
// leaves it out for organisations support switched the feature off for (see SidebarNavigation).
// `new: true` tags a new feature "New"; there are none right now.
const ukNavigationConfig = [
  {
    id: 'command-centre',
    title: 'Home',
    type: 'item',
    img: homeIcon,
    url: 'command-centre',
    auth: authRoles.pharmacist,
  },
  {
    id: 'dashboard',
    title: 'Insights',
    type: 'item',
    img: insightsIcon,
    url: 'dashboard',
    auth: authRoles.pharmacist,
  },
  {
    id: 'announcements',
    title: "What's New",
    translate: 'ANNOUNCEMENTS',
    type: 'item',
    img: whatsNewIcon,
    url: 'announcements',
    display: false,
    unreadDot: true,
    auth: authRoles.pharmacist,
  },
  {
    id: 'pro',
    title: 'Upgrades',
    type: 'item',
    img: proIcon,
    colourIcon: true,
    url: 'healthera-pro',
    display: false,
  },
  {
    id: 'workflow',
    title: 'Workflow',
    type: 'group',
    children: [
      { ...patientsItem, auth: authRoles.pharmacist },
      {
        id: 'orders',
        title: 'Orders',
        translate: 'ORDERS',
        type: 'link',
        img: ordersIcon,
        url: `${config.connectV1Url}/repeats/requested/`,
        target: '_self',
        auth: authRoles.pharmacist,
      },
      {
        id: 'overdue-orders',
        title: 'Attention',
        type: 'link',
        img: attentionIcon,
        url: `${config.connectV1Url}/overdue`,
        target: '_self',
        auth: authRoles.pharmacist,
      },
      {
        id: 'patients-help',
        title: 'Patient help',
        type: 'item',
        img: patientHelpIcon,
        url: 'patients-help',
        auth: authRoles.pharmacist,
      },
      {
        id: 'prescribing',
        title: 'Prescribing',
        type: 'item',
        img: prescribingIcon,
        url: 'prescribing',
        addOn: true,
        auth: authRoles.prescriberAndSupport,
      },
      {
        id: 'managed-repeats',
        title: 'Managed repeats',
        type: 'item',
        img: managedRepeatsIcon,
        url: 'managed-repeats',
        plusFeature: 'digitalManagedRepeats',
        countColour: 'green',
        auth: authRoles.pharmacist,
      },
    ],
  },
  {
    id: 'appointment-booking',
    title: 'Services',
    type: 'group',
    children: [
      { ...calendarItem, auth: authRoles.pharmacist },
      { ...servicesItem, auth: authRoles.pharmacist },
      {
        id: 'organisation-questionnaires',
        title: 'Questionnaires',
        translate: 'QUESTIONNAIRES',
        type: 'item',
        img: questionnairesIcon,
        url: 'organisation-questionnaires',
        auth: authRoles.pharmacist,
      },
      {
        id: 'group-dashboard',
        title: 'Services dashboard',
        type: 'item',
        img: servicesDashboardIcon,
        url: `service-dashboard`,
        auth: authRoles.pharmacist,
      },
      {
        id: 'pgd',
        title: 'PGDs',
        type: 'item',
        img: pgdsIcon,
        url: 'pgd',
        auth: authRoles.pharmacist,
      },
    ],
  },
  {
    id: 'products',
    title: 'Shop',
    type: 'group',
    children: [
      {
        id: 'products-list-org',
        title: 'OTC & Uber catalogue',
        type: 'item',
        img: otcUberCatalogueIcon,
        url: 'products',
        auth: authRoles.pharmacist,
      },
      {
        id: 'products-list-pharmacy',
        title: 'Branch catalogue',
        type: 'item',
        img: branchCatalogueIcon,
        url: 'pharmacy-products',
        auth: authRoles.pharmacist,
      },
      {
        id: 'product-library',
        title: 'Product library',
        type: 'item',
        img: productLibraryIcon,
        url: 'product-library',
        auth: authRoles.support,
      },
      {
        id: 'product-categories',
        title: 'Product categories',
        type: 'item',
        img: productLibraryIcon,
        url: 'product-categories',
        auth: authRoles.support,
      },
    ],
  },
  {
    id: 'marketing-station',
    title: 'Grow & automate',
    type: 'group',
    featured: true,
    auth: authRoles.pharmacist,
    children: [
      { ...broadcastsItem, auth: authRoles.pharmacist },
      { ...smsCampaignsItem, auth: authRoles.pharmacist },
      {
        id: 'marketing-material',
        title: 'Marketing materials',
        type: 'item',
        img: marketingMaterialsIcon,
        url: 'marketing-material',
        auth: authRoles.pharmacist,
      },
      {
        ...websiteBuilderItem,
        plusFeature: 'webBuilderAccessEnabled',
        // Every pharmacy user gets the builder. Writes are guarded by the API rather than the
        // router, so a plain pharmacist browses and previews without changing the live site.
        auth: authRoles.pharmacist,
      },
      { ...superLinksItem, plusFeature: 'superLinks', auth: authRoles.pharmacist },
      {
        id: 'in-app-banners',
        title: 'In-App Banner',
        type: 'link',
        img: inAppBannerIcon,
        url: `${config.connectV1Url}/banners`,
        target: '_self',
        plusFeature: 'inAppBanners',
        auth: authRoles.pharmacist,
      },
    ],
  },
  {
    id: 'admin',
    title: 'Admin',
    type: 'group',
    children: [
      { ...userManagementItem, auth: authRoles.pharmacyAdmin },
      {
        id: 'billing-and-reports',
        title: 'Billing and reports',
        type: 'item',
        img: billingAndReportsIcon,
        url: 'documents',
        auth: authRoles.pharmacyAdmin,
      },
      {
        id: 'training-and-guides',
        title: 'Training and guides',
        type: 'item',
        img: trainingAndGuidesIcon,
        url: 'training-and-guides',
        auth: authRoles.pharmacist,
      },
      {
        id: 'reviews',
        title: 'Reviews',
        translate: 'REVIEWS',
        type: 'link',
        img: reviewsIcon,
        url: `${config.connectV1Url}/reviews`,
        target: '_self',
        auth: authRoles.pharmacist,
      },
      {
        id: 'pharmacies',
        title: 'Pharmacy setup',
        type: 'link',
        img: pharmaciesIcon,
        url: `${config.connectV1Url}/pharmacies`,
        target: '_self',
        auth: authRoles.pharmacist,
      },
      {
        id: 'online-shop',
        title: 'Online Shop',
        translate: 'ONLINESHOP',
        type: 'link',
        img: branchCatalogueIcon,
        url: `${config.connectV1Url}/online-shop`,
        target: '_self',
        display: false,
        auth: authRoles.pharmacist,
      },
    ],
  },
  {
    id: 'staff',
    title: 'Staff',
    type: 'group',
    auth: authRoles.support,
    children: [
      { ...masterServicesItem, auth: authRoles.support },
      { ...lunarReviewsItem, auth: authRoles.support },
      {
        id: 'questionnaires-list',
        title: 'Questionnaires',
        translate: 'QUESTIONNAIRES',
        type: 'item',
        img: productLibraryIcon,
        url: 'questionnaires',
        auth: authRoles.support,
      },
      {
        id: 'pgd-manage',
        title: 'PGD Manage',
        type: 'item',
        img: productLibraryIcon,
        url: 'pgd-manage',
        auth: authRoles.support,
      },
      {
        id: 'rx-management',
        title: 'Rx Management',
        type: 'item',
        img: productLibraryIcon,
        url: 'rx-management',
        auth: authRoles.support,
      },
      {
        id: 'users',
        title: 'Users',
        translate: 'USERS',
        type: 'link',
        img: usersIcon,
        url: `${config.connectV1Url}/users`,
        target: '_self',
        auth: authRoles.support,
      },
    ],
  },
];

export default ukNavigationConfig;
